import axiosInstanceNew from "../lib/axiosinstanceNew";

const BlogModal = class {

    constructor(){
        this.baseUrl="blogs";
    }
    async Getblog(){
        return(
            await axiosInstanceNew.get(`${this.baseUrl}`)
        )
    }
    async Addblog(data =[]){
        return(
            await axiosInstanceNew.post(`${this.baseUrl}`,data)
        )
    }
    async deleteBlog(id){
        return(
            await axiosInstanceNew.delete(`${this.baseUrl}/${id}`)
        )
    }
    async Editblog(id, data=[]){
        return(
            await axiosInstanceNew.put(`${this.baseUrl}/${id}`,data)
        )
    }
}
export default new BlogModal();